import type { VueCookies } from 'vue-cookies'

import { useAppStore } from '@/stores/app'

export function useAppCookies() {
  const appStore = useAppStore()
  // Use `@ts-expect-error` instead of `@ts-ignore`
  // @ts-expect-error: $cookies is dynamically injected
  const cookies = $cookies as VueCookies
  const getCookies = (key: string): unknown => {
    return cookies.get(key)
  }
  const setCookies = <T>(key: string, value: T): VueCookies => {
    return cookies.set(key, value, undefined, undefined, appStore.getPortalDomain)
  }

  const removeCookies = (
    key: string,
    path?: string,
    domain: string = appStore.getPortalDomain,
  ): boolean => {
    return cookies.remove(key, path, domain)
  }

  return { cookies, getCookies, setCookies, removeCookies }
}
